import { render } from "./BarcodeWrapper.vue?vue&type=template&id=298c7882&scoped=true&ts=true"
import script from "./BarcodeWrapper.vue?vue&type=script&lang=ts"
export * from "./BarcodeWrapper.vue?vue&type=script&lang=ts"

import "./BarcodeWrapper.vue?vue&type=style&index=0&id=298c7882&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298c7882"]])

export default __exports__